import { useFlags } from 'launchdarkly-react-client-sdk';
import { ReactNode } from 'react';

type FlagProps = { flag: string; on?: ReactNode; off?: ReactNode };
export function Flag({ flag, on = null, off = null }: FlagProps) {
  const flags = useFlags();
  return flags[flag] ? on : off;
}
